import { usePublishEvent } from '@/analytics/usePublishEvent';
import type { TextFieldProps } from '@soluto-private/mx-asurion-ui-react';
import classNames from 'classnames';
import { Dispatch, SetStateAction, useRef, useState } from 'react';
import { TextInput } from '../TextInput';
import styles from './identifier-input.module.scss';
import { SuggestDomain } from './SuggestDomain';

export type IdentifierInputProps = TextFieldProps & {
  setInput: Dispatch<SetStateAction<string>>;
  inputValid?: boolean;
  phoneOnly?: boolean;
};

export const IdentifierInput = ({
  setInput,
  inputValid,
  phoneOnly,
  inputClassName,
  containerClassName,
  onChange,
  ...props
}: IdentifierInputProps) => {
  const publishEvent = usePublishEvent();
  const [focused, setFocused] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const showSuggestions =
    !phoneOnly &&
    props.value?.toString().includes('@') &&
    focused &&
    !props.disabled &&
    !inputValid;

  const handleDomainClick = (selection: string) => {
    setInput((email) => `${email.split('@')[0]}@${selection}`);
    setFocused(false);
    inputRef.current?.blur();
    publishEvent('SuggestionClick', 'suggest-domain', {
      selectedDomain: selection,
    });
  };

  return (
    <div className={styles.wrapper}>
      <TextInput
        type={phoneOnly ? 'tel' : undefined}
        inputMode={phoneOnly ? 'tel' : 'email'}
        maxLength={phoneOnly ? 12 : undefined}
        {...props}
        ref={inputRef}
        autoComplete={showSuggestions ? 'off' : 'on'}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        inputClassName={classNames('fs-mask', inputClassName)}
        containerClassName={classNames(
          styles.textFieldContainer,
          showSuggestions && styles.withSuggestion,
          containerClassName,
        )}
        onChange={(e) => {
          setInput(e.target.value.replace(/\s/g, ''));
          onChange?.(e);
        }}
      />
      {showSuggestions && (
        <SuggestDomain
          hasFieldDescription={!!props.helperText}
          prefix={props.value?.toString() ?? ''}
          onSuggestionClick={handleDomainClick}
        />
      )}
    </div>
  );
};
